import React, { Fragment, useState } from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { MainDrawer } from '../../../CommonComponent/MainDrawer';
import { CreateSkillFramework } from './CreateSkillFramework';

export const SkillFrameworkDrawer: React.FC<any> = (props: any) => {
	const {
		skillFrameworkOpen,
		setSkillFrameworkOpen,
		skillFramework,
		handleOnChange,
		handleLevelChange,
		handleAddLevel,
		handleRemoveLevel,
		handleProficiencyChange,
		handleAddProficiency,
		handleRemoveProficiency,
		handleSaveFramework,
		frameworkError,
		setFrameworkError,
	} = props;
	const { t } = useTranslation();
	const handleDrawerClose = (event: any, type: string) => {
		if (type === 'save') {
			setSkillFrameworkOpen(false);
		} else {
			setSkillFrameworkOpen(false);
		}
	};
	return (
		<MainDrawer
			open={skillFrameworkOpen}
			drawerClassName={`main-drawer-panel main-drawer-titlepanel`}
			transitionDuration={{ enter: 500, exit: 1000 }}
			headerTitle={t('Skill Framework')}
			//loader={loader}
			children={
				<Box className='drawer-inner-content'>
					<CreateSkillFramework
						skillFramework={skillFramework}
						handleOnChange={handleOnChange}
						handleLevelChange={handleLevelChange}
						handleAddLevel={handleAddLevel}
						handleRemoveLevel={handleRemoveLevel}
						handleProficiencyChange={handleProficiencyChange}
						handleAddProficiency={handleAddProficiency}
						handleRemoveProficiency={handleRemoveProficiency}
						frameworkError={frameworkError}
						setFrameworkError={setFrameworkError}
					/>
				</Box>
			}
			saveButtonText={t('saveBtn')}
			//isSaveButtonDisabled={selectedIds.length === 0}
			isFooterVisible={true}
			rightCloseBtn={true}
			handleDrawerClose={(event: any) => handleDrawerClose(event, 'close')}
			handleSaveClick={(event: any) => handleSaveFramework(event, 'save')}
			handleCancelClick={(event: any) => handleDrawerClose(event, 'cancel')}
		/>
	);
};
